import { combineReducers } from 'redux';

import alternateRoyalty from './alternate_royalty/reducer';
import propertyManagement from './property_management/reducer';
import royaltySchedules from './royalty_schedules/reducer';

const nullReducer = state => state || {};

export default combineReducers({
  alternateRoyalty,
  isParentCompanyUser: isParentCompanyUser => !!isParentCompanyUser,
  paths: nullReducer,
  propertyManagement,
  royaltySchedules,
});
